import { render, staticRenderFns } from "./lowThreshold-editor.vue?vue&type=template&id=9c5afcde&scoped=true&"
import script from "./lowThreshold-editor.vue?vue&type=script&lang=js&"
export * from "./lowThreshold-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c5afcde",
  null
  
)

export default component.exports